var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11027",
    "data-name": "Group 11027",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.233,
    height: 9.253,
    viewBox: "0 0 13.233 9.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4357",
    "data-name": "Rectangle 4357",
    width: 13.233,
    height: 9.253,
    fill: "#030"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11027-2",
    "data-name": "Group 11027",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44766",
    "data-name": "Path 44766",
    d: "M6.6,1.319q-2.919,0-5.837,0a.8.8,0,0,1-.517-.129A.766.766,0,0,1,.006.582.647.647,0,0,1,.751,0Q6.634.005,12.518,0a.62.62,0,0,1,.654.368.659.659,0,0,1-.374.917,1.022,1.022,0,0,1-.317.03q-2.942,0-5.884,0",
    transform: "translate(0 0)",
    fill: "#030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44767",
    "data-name": "Path 44767",
    d: "M52.691,97.224q-1.927,0-3.855,0a1.172,1.172,0,0,1-.345-.037.676.676,0,0,1-.306-1,.578.578,0,0,1,.474-.274c.046,0,.093,0,.139,0h7.833a.622.622,0,0,1,.631.335.668.668,0,0,1-.367.957.866.866,0,0,1-.289.024q-1.958,0-3.916,0",
    transform: "translate(-46.087 -91.938)",
    fill: "#030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44768",
    "data-name": "Path 44768",
    d: "M98.511,193.064c-.686,0-1.372,0-2.058,0a.557.557,0,0,1-.54-.426.683.683,0,0,1,.1-.629.532.532,0,0,1,.44-.246c.361-.011.722-.008,1.083-.008q1.478,0,2.955,0a.609.609,0,0,1,.615.336.67.67,0,0,1-.368.957.817.817,0,0,1-.273.023c-.65,0-1.3,0-1.95,0v-.006",
    transform: "translate(-91.908 -183.817)",
    fill: "#030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.58ae4220729bcbfe044ab6ed04fe0db3.svg";
export { ForwardRef as ReactComponent };